var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-singlePage",class:{'no-bg':_vm.nobg, 'overflow-hidden': _vm.overflowCss === 0}},[_c('div',{staticClass:"container",class:{'step0': _vm.step===0}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }